<template>
	<AppLoader class="flex-centerize mt-15" v-if="isLoading" />
	<h3 class="text-align-center reg mt-15" v-else-if="showNoResults">No logs found</h3>
	<Col class="width-100 height-100" v-else>
		<Row class="header-section flex-space-between--center mt-7">
			<Row>Name</Row>
			<Row class="pr-9">Status</Row>
		</Row>
		<router-link
			custom
			class="no-decoration"
			:key="taskLogItem.id"
			v-for="taskLogItem in taskLogItems"
			v-slot="{ isActive, href, navigate }"
			:to="{ name: BUILDER_TASK_LOG_INNER_PAGE, params: { taskLogId: taskLogItem.id } }"
		>
			<a :href="href" @click="(e) => openLogDetails({ e, navigate, taskLogId: taskLogItem.id })">
				<TaskLogListItem :triggeredFlow="taskLogItem" :isSelected="isActive" />
			</a>
		</router-link>
	</Col>
</template>
<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { getTaskLog } from '@/store/modules/analytics/actions';
import TaskLogListItem from '@/components/TaskLog/TaskLogListItem';
import { BUILDER_TASK_LOG_INNER_PAGE } from '@/router/router.const.js';
export default {
	name: 'BuilderTaskLog',
	components: { TaskLogListItem },
	props: {
		hasEditPermissions: { type: Boolean },
		wfID: { type: Number, required: true },
	},
	computed: {
		...mapGettersShorthand({ editWorkflow }),
		showNoResults() {
			return this.taskLogItems.length === 0;
		},
	},
	methods: {
		...mapActionsShorthand({ getTaskLog }),
		openLogDetails({ e, navigate }) {
			// navigate is the default func exposed by the RouterLink component, because we want after navigating to focus on the clicked element
			navigate(e);
			e.stopPropagation();
			e.preventDefault();
		},
		closeDrawer() {
			this.$emit('close');
		},
		async fetchTaskLog() {
			try {
				this.isLoading = true;
				this.taskLogItems = await this.getTaskLog({ flow: this.wfID, projectId: this.editWorkflow.project });
			} catch {
				this.$toast.error('Something went wrong, please try again later');
				this.closeDrawer();
			} finally {
				this.isLoading = false;
			}
		},
	},
	created() {
		this.fetchTaskLog();
	},
	data() {
		return {
			taskLogItems: [],
			isLoading: false,
			selectedTaskLogId: null,
			BUILDER_TASK_LOG_INNER_PAGE,
		};
	},
};
</script>
<style scoped lang="scss">
.task-log-title {
	font-size: 20px;
	font-weight: medium;
	color: var(--primary-font-color);
}
.close-button {
	width: 22px !important;
	height: 22px !important;
	font-size: 12px !important;
	color: #5a677c !important;
	font-weight: normal !important;
	background: #f5f7fa !important;
	border: 1px solid #e7eaf3 !important;
}
.header-section {
	font-size: 12px;
	color: var(--secondary-font-color);
	border-bottom: var(--tertiary-border);
}
.no-decoration {
	text-decoration: none;
}
.task-log-container {
	max-width: $builder-task-log-width;
	min-width: $builder-task-log-width;
}
</style>
